<p-dialog id="set-layout-dialog" class="campaign-dialog" [positionTop]="40" [positionLeft]="'50%'"
  [header]="'campaign.setLayout' | translate" [width]="1100" [(visible)]="visible" [modal]="true"
  [draggable]="false" [resizable]="false" (onHide)="close.emit()"
  [contentStyle]="{'max-height': '90vh', 'overflow': 'auto'}">

  <div style="display: flex; gap: 20px; align-items: flex-start; min-height: 400px;">

    <!-- LEFT SIDEBAR -->
    <div *ngIf="layoutData && layoutData.form_schema && layoutData.form_schema.properties"
      style="flex: 0 0 320px; background: #f9f9f9; padding: 15px; border-radius: 5px; position: sticky; top: 0; max-height: 65vh; overflow-y: auto;">

      <h4 style="margin-top: 0; margin-bottom: 10px; color: #20417b;" [translate]="'campaign.touchpoint_active_fields'">
      </h4>
      <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 25px;">
        <span *ngIf="activeFields.length === 0" style="color:#777; font-style:italic;"
          [translate]="'campaign.touchpoint_no_active_fields'"></span>
        <span *ngFor="let field of activeFields"
          style="display: flex; justify-content: space-between; align-items: center; background: #fff; border: 1px solid #ccc; padding: 6px 10px; border-radius: 4px; font-size: 13px;">
          <span *ngIf="field.isDet">{{ 'campaign.touchpoint_detail' | translate }} {{field.label}}</span>
          <span *ngIf="!field.isDet">{{field.label | translate}}</span>
          <i class="fa fa-times" style="color: #e2001a; cursor: pointer; margin-left:10px;"
            (click)="removeField.emit(field)" title="{{ 'campaign.touchpoint_deactivate_field' | translate }}"></i>
        </span>
      </div>

      <h4 style="margin-top: 0; margin-bottom: 10px; color: #555;" [translate]="'campaign.touchpoint_available_fields'">
      </h4>
      <div style="display: flex; flex-direction: column; gap: 8px;">
        <span *ngIf="inactiveFields.length === 0" style="color:#777; font-style:italic;"
          [translate]="'campaign.touchpoint_all_fields_active'"></span>
        <span *ngFor="let field of inactiveFields"
          style="display: flex; justify-content: space-between; align-items: center; background: #e9ecef; border: 1px dashed #ccc; padding: 6px 10px; border-radius: 4px; font-size: 13px; color: #666;">
          <span *ngIf="field.isDet">{{ 'campaign.touchpoint_detail' | translate }} {{field.label}}</span>
          <span *ngIf="!field.isDet">{{field.label | translate}}</span>
          <i class="fa fa-plus" style="color: #28a745; cursor: pointer; margin-left:10px;"
            (click)="addField.emit(field)" title="{{ 'campaign.touchpoint_add_field' | translate }}"></i>
        </span>
      </div>
    </div>

    <!-- RIGHT MAIN CONTENT -->
    <div style="flex: 1; min-width: 0; pointer-events: none; user-select: none; opacity: 0.85;">
      <div *ngIf="renderSchemaViewer">
        <app-kv-json-form-schema [formData]="layoutDataForDisplay" [readOnly]="true">
        </app-kv-json-form-schema>
      </div>

      <div *ngIf="missingLayout" style="margin-top: 15px;">
        <span class="fa fa-warning"
          style="color:#F9A12E;font-size: 25px;margin: 10px 10px 0 0;vertical-align: middle;"></span>
        <label [translate]="'campaign.missingLayout'"></label>
      </div>
    </div>
  </div>

  <p-footer>
    <button pButton type="button" class="k-generic-btn" icon="fa-check" label="{{ 'campaign.applyStructure' | translate }}"
      (click)="save.emit()"></button>
    <button pButton type="button" class="k-generic-btn" icon="fa-close" label="{{ 'common.cancel' | translate }}"
      (click)="close.emit()"></button>
  </p-footer>
</p-dialog>


// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/components/touchPointLayoutDialog.component.html